import { accountHandoffUrl } from "./canonical-link";
import { readTabAccountId } from "./tab-account";

let installed = false;

export function installNewTabAccountHandoff(): void {
  if (installed || typeof window === "undefined") {
    return;
  }
  installed = true;

  window.addEventListener(
    "click",
    (event) => {
      const isMiddleClick = event.button === 1;
      const isModifiedClick = (event.ctrlKey || event.metaKey) && event.button === 0;

      if (!isMiddleClick && !isModifiedClick) {
        return;
      }

      const target = event.composedPath()[0];
      const anchor = target instanceof Element ? target.closest("a") : null;
      if (!anchor) {
        return;
      }

      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("javascript:")) {
        return;
      }

      try {
        const url = new URL(anchor.href, window.location.origin);
        if (url.origin !== window.location.origin) {
          return;
        }

        const activeUserId = readTabAccountId();
        if (!activeUserId) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const handoffHref = accountHandoffUrl(anchor.href, activeUserId);
        window.open(handoffHref, "_blank");
      } catch {
        // Fallback to default
      }
    },
    { capture: true },
  );
}
